// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1W3EO","content":"styles_content__1QeMc","checkbox":"styles_checkbox__EMqfg","checkboxLabel":"styles_checkboxLabel__2Sdh8"};